var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerupCheckOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.3333C17.7513 29.3356 19.4858 28.9918 21.1037 28.3215C22.7217 27.6513 24.1913 26.668 25.428 25.428C26.668 24.1913 27.6513 22.7217 28.3215 21.1037C28.9918 19.4858 29.3356 17.7513 29.3333 16C29.3356 14.2487 28.9917 12.5143 28.3215 10.8963C27.6513 9.27832 26.6679 7.80874 25.428 6.572C24.1913 5.33202 22.7217 4.34867 21.1037 3.67846C19.4858 3.00825 17.7513 2.6644 16 2.66667C14.2487 2.66444 12.5143 3.0083 10.8963 3.67851C9.27832 4.34872 7.80874 5.33205 6.572 6.572C5.33205 7.80874 4.34872 9.27832 3.67851 10.8963C3.0083 12.5143 2.66444 14.2487 2.66667 16C2.6644 17.7513 3.00825 19.4858 3.67846 21.1037C4.34867 22.7217 5.33202 24.1913 6.572 25.428C7.80874 26.6679 9.27832 27.6513 10.8963 28.3215C12.5143 28.9917 14.2487 29.3356 16 29.3333Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerupCheckOff);
export default __webpack_public_path__ + "static/media/powerup_check_off.fe78439f59ee3d7f29472a28aee65102.svg";
export { ForwardRef as ReactComponent };